import { useEffect, useState } from "react";
import i18n from "../i18n";
import JsonApiService from "../services/jsonapiService";
import { visionURL } from "../config/environment";
import Jsona from "jsona";

const dataFormatter = new Jsona();

const trainingObjectTypesService = async typesFor =>
  new JsonApiService(`training_object_types?typesFor=${typesFor}`, {
    baseUrl: `${visionURL}/admin_console/api/administration`,
    credentials: "include"
  });

export const useTrainingObjectTypes = typesFor => {
  const [isLoading, setIsLoading] = useState(false);
  const [trainingObjectTypes, setTrainingObjectTypes] = useState(null);
  const [trainingObjectTypeOptions, setTrainingObjectTypeOptions] = useState(
    []
  );

  const forAssignable = () => typesFor === "assignable";

  useEffect(() => {
    const fetchTrainingObjectTypes = async () => {
      setIsLoading(true);
      const service = await trainingObjectTypesService(typesFor);
      const response = await service.all().then(response => response.json());
      setIsLoading(false);
      setTrainingObjectTypes(dataFormatter.deserialize(response));
    };
    fetchTrainingObjectTypes();
  }, []);

  useEffect(() => {
    if (trainingObjectTypes) {
      setTrainingObjectTypeOptions([
        {
          label: i18n.t(
            `administration.addAssignmentModal.${typesFor}PlaceHolder`
          ),
          value: forAssignable() ? "all" : ""
        },
        ...trainingObjectTypes.map(trainingObjectType => ({
          label: i18n.t(
            `administration.addAssignmentModal.courseTypes.${trainingObjectType.description.replace(
              /\s+/g,
              ""
            )}`
          ),
          value: forAssignable()
            ? trainingObjectType.valueForSelect
            : trainingObjectType.id
        }))
      ]);
    }
  }, [trainingObjectTypes]);

  return {
    trainingObjectTypes,
    trainingObjectTypeOptions,
    isLoading
  };
};
